// @flow
import * as React from 'react';

import parseMetadata from './parseMetadata';

type Result = {
    schema: $FixMe,
    uiSchema: $FixMe
};

const useParseMetadata = (metadata: $FixMe): Result =>
    React.useMemo(() => parseMetadata(metadata), [metadata]);

export default useParseMetadata;
